import { useState } from 'react'
import { Translate } from 'react-redux-i18n'
import { Button } from '../../../common/html/button'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { PopupContactUs } from '../../../common/order/popup/popupContactUs'
import classes from '../index.module.scss'

export const TitleAndContact = () => {
  const [isOpenPopupContactUs, setIsOpenPopupContactUs] = useState(false)

  const onOpenPopupContactUs = () => {
    setIsOpenPopupContactUs(true)
  }

  const onClosePopupContactUs = () => {
    setIsOpenPopupContactUs(false)
  }

  return (
    <Element className="dFlex alignItemsCenter justifyContentBetween mt1">
      <Element
        className="textUppercase fw600"
        style={{ color: '#0553A5', fontSize: 24 }}
      >
        <Translate value="companyAnalysis.peerAnalysis.PEER_ANALYSIS" />
      </Element>

      <Button
        label={
          <div className="dFlex alignItemsCenter">
            <span className="whiteSpaceNowrap">
              <Translate value="companyAnalysis.peerAnalysis.CONTACT_US" />
            </span>
            <Icon className="icon-arrow-right ml1" style={{ fontSize: 10 }} />
          </div>
        }
        className={classes.contactUsButton}
        style={{
          backgroundColor: '#FFFFFF',
          borderColor: '#D1D1D1',
        }}
        action={onOpenPopupContactUs}
      />
      <PopupContactUs
        isOpen={isOpenPopupContactUs}
        onClose={onClosePopupContactUs}
      />
    </Element>
  )
}
